const imageAssocData = [
    {
        "id": 43,
        "usr_id": 1,
        "img_name": "procione_mini.jpg",
        "img_id": 10,
        "album_name": "Beach",
        "album_id": 10,
        "created_on": "2022-09-24 06:24:26",
        "status": "active"
    },
    // {
    //     "id": "1",
    //     "usr_id": "1",
    //     "img_name": "a-wonderful-woman_mini.JPG",
    //     "img_id": "503",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 11:11:27"
    // },
    // {
    //     "id": "2",
    //     "usr_id": "1",
    //     "img_name": "piramid-building_mini.JPG",
    //     "img_id": "502",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 11:12:59"
    // },
    // {
    //     "id": "3",
    //     "usr_id": "1",
    //     "img_name": "procione_mini.jpg",
    //     "img_id": "501",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 11:13:50"
    // },
    // {
    //     "id": "4",
    //     "usr_id": "1",
    //     "img_name": "5dcf7906-3b49-486c-a83c-d4d7b2a4b018_mini.jpeg",
    //     "img_id": "500",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 11:21:37"
    // },
    // {
    //     "id": "5",
    //     "usr_id": "1",
    //     "img_name": "20b1102a-7632-4d77-81ff-324890b2d053_mini.jpeg",
    //     "img_id": "499",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 11:21:44"
    // },
    // {
    //     "id": "6",
    //     "usr_id": "1",
    //     "img_name": "3354f8d4-4cca-473b-a197-c9cd6bf93b30_mini.jpeg",
    //     "img_id": "498",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 11:22:19"
    // },
    // {
    //     "id": "7",
    //     "usr_id": "1",
    //     "img_name": "20b1102a-7632-4d77-81ff-324890b2d053_mini.jpeg",
    //     "img_id": "499",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 12:10:36"
    // },
    // {
    //     "id": "8",
    //     "usr_id": "1",
    //     "img_name": "6a4323c8-d0da-4e6c-88a2-34718ee28f3a_mini.jpeg",
    //     "img_id": "503",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 12:13:11"
    // },
    // {
    //     "id": "9",
    //     "usr_id": "1",
    //     "img_name": "the-honorable-choice_mini.jpg",
    //     "img_id": "490",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:25:52"
    // },
    // {
    //     "id": "10",
    //     "usr_id": "1",
    //     "img_name": "acbcdf12-4805-4e84-b7ed-b845285f3fbf_mini.jpeg",
    //     "img_id": "496",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:26:50"
    // },
    // {
    //     "id": "11",
    //     "usr_id": "1",
    //     "img_name": "the-medallion_mini.jpg",
    //     "img_id": "489",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:28:08"
    // },
    // {
    //     "id": "12",
    //     "usr_id": "1",
    //     "img_name": "the-fields-we-called-home_mini.jpg",
    //     "img_id": "492",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:30:36"
    // },
    // {
    //     "id": "13",
    //     "usr_id": "1",
    //     "img_name": "62733cb4-607d-4bc9-93ce-8ceab6001a80_mini.jpeg",
    //     "img_id": "466",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:38:58"
    // },
    // {
    //     "id": "14",
    //     "usr_id": "1",
    //     "img_name": "the stranger in the lifeboat_mini.jpg",
    //     "img_id": "491",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:40:07"
    // },
    // {
    //     "id": "15",
    //     "usr_id": "1",
    //     "img_name": "c4df9aa1-f00f-4327-91ca-ec0392b09d8e_mini.jpeg",
    //     "img_id": "461",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:44:45"
    // },
    // {
    //     "id": "16",
    //     "usr_id": "1",
    //     "img_name": "fd9f006c-b337-4620-ad35-cedc8c2a2df1_mini.jpeg",
    //     "img_id": "456",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:46:04"
    // },
    // {
    //     "id": "17",
    //     "usr_id": "1",
    //     "img_name": "7bbdb49a-5e8f-4240-8a12-3f9f86ce5f7f_mini.jpeg",
    //     "img_id": "455",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:46:56"
    // },
    // {
    //     "id": "18",
    //     "usr_id": "1",
    //     "img_name": "dc16895e-c211-4d72-8627-647637fa1612_mini.jpeg",
    //     "img_id": "453",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:47:52"
    // },
    // {
    //     "id": "19",
    //     "usr_id": "1",
    //     "img_name": "04768663-3033-4637-af1b-db0dfd67362b_mini.jpeg",
    //     "img_id": "452",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:48:26"
    // },
    // {
    //     "id": "20",
    //     "usr_id": "1",
    //     "img_name": "7a21a8e8-a0c1-4c34-a0f1-11d6d38300d2_mini.jpeg",
    //     "img_id": "451",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:49:58"
    // },
    // {
    //     "id": "21",
    //     "usr_id": "1",
    //     "img_name": "3c95c5d0-52aa-4d55-bfc5-3738673b1372_mini.jpeg",
    //     "img_id": "346",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:50:56"
    // },
    // {
    //     "id": "22",
    //     "usr_id": "1",
    //     "img_name": "34a47adb-9a5f-4212-bda8-68ebc912a64e_mini.jpeg",
    //     "img_id": "335",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:51:32"
    // },
    // {
    //     "id": "23",
    //     "usr_id": "1",
    //     "img_name": "c0ed8e87-6ef0-4ffe-9e92-3d4d77ccfd86_mini.jpeg",
    //     "img_id": "334",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 13:54:29"
    // },
    // {
    //     "id": "24",
    //     "usr_id": "1",
    //     "img_name": "173ed69b-51c6-48b9-b524-48d64d3dd8f0_mini.jpeg",
    //     "img_id": "322",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 16:32:31"
    // },
    // {
    //     "id": "25",
    //     "usr_id": "1",
    //     "img_name": "43c63ca5-f853-4f1b-94ec-ca58aeda91a7_mini.jpeg",
    //     "img_id": "312",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 16:50:37"
    // },
    // {
    //     "id": "26",
    //     "usr_id": "1",
    //     "img_name": "6d6bec14-b4d6-47b1-a28a-189b8c416698_mini.jpeg",
    //     "img_id": "299",
    //     "album_name": "new album",
    //     "album_id": "1",
    //     "created_on": "2022-09-22 17:12:58"
    // }
];
export default imageAssocData;